import {ChangeEvent, FunctionComponent, InputHTMLAttributes, useCallback, useEffect, useState} from 'react';
import Input from '@/components/form/input';

type InputProps = InputHTMLAttributes<HTMLInputElement>;

const PercentageInput: FunctionComponent<InputProps> = ({value, onChange, ...props}) => {
  const [activeValue, setActiveValue] = useState(value ?? 0);
  const [previousValue, setPreviousValue] = useState<number>(0);

  const onHandleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      let value = parseInt(event.target.value, 10);
      value = isNaN(value) ? 0 : value;

      if (value > 100) {
        setActiveValue(previousValue);
      } else {
        setActiveValue(value);
        if (value !== 0) setPreviousValue(value);

        onChange?.({...event, target: {...event.target, value: value.toString()}});
      }
    },
    [previousValue, onChange],
  );

  useEffect(() => {
    if (value === undefined) return;
    setActiveValue(value);
  }, [value]);

  return (
    <div className="relative w-full">
      <Input
        {...props}
        type="number"
        labelWithinInput="%"
        pattern="^[0-9]{1,3}$"
        maxLength={3}
        value={activeValue}
        onChange={onHandleChange}
      />
    </div>
  );
};

export default PercentageInput;
